// 基础地址配置
//const REMOTE_URL = "http://127.0.0.1";
const REMOTE_URL = "https://lezhiyi.online";

// 前端部署基础路径（修改这里即可改变前端访问地址）
export const FRONTEND_BASE_PATH = "/webSite/family_dkp/frontend/dist";

// 判断是否为开发环境
const isDev = import.meta.env.DEV;

// 调试：打印环境变量
console.log("[apiConfig] isDev:", isDev, "import.meta.env.DEV:", import.meta.env.DEV);

// 后端 API 基础路径
export const API_CONFIG = {
    BASE_URL: `${REMOTE_URL}/webSite/family_dkp`,
    API_BASE_PATH: "/api",
    get FULL_API_BASE_URL() {
        // 开发环境：使用 /api（Vite 代理会处理重写）
        // 生产环境：使用完整路径
        const url = isDev ? this.API_BASE_PATH : this.BASE_URL + this.API_BASE_PATH;
        console.log("[apiConfig] FULL_API_BASE_URL:", url);
        return url;
    },
    // 获取完整前端基础地址
    get FULL_FRONTEND_URL() {
        return REMOTE_URL + FRONTEND_BASE_PATH;
    },
};

export default API_CONFIG;
